/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
import { Image, Form, Button, Input, Result, Toast } from "antd-mobile-v5";
import styled from "styled-components";
import { getQueryString } from "../../util/getQueryString";
import { useHistory } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import instance from "../../util/axios";
import CryptoJs from "crypto-js";
const RegisterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f8f8f7;
  .navBar {
    background: #fff;
  }
  .main {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .logo {
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 20px;
    width: 130px;
  }
  .user-box {
    text-align: center;
    margin-bottom: 20px;
    font-size: 14px;
    font-weight: 600;
  }
  .user {
    color: #1677ff;
  }
  .company-box {
    text-align: center;
    margin-bottom: 40px;
    font-size: 20px;
    font-weight: 600;
  }
  .adm-form {
    flex: 1;
    display: flex;
    flex-direction: column;
    .adm-list {
      flex: 1;
    }
    .adm-list-body-inner {
      padding: 0 8px;
      font-size: 15px;
    }
  }
  .pc-form {
    .adm-list {
      flex: none;
    }
  }
  .adm-input-element {
    font-size: 15px;
  }
`;
export function isMobile() {
  let flag = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
  return flag;
}

const userId: string = getQueryString("userId") || "";
const corpId: string = getQueryString("corpId") || "";
const expiringDate = Number(getQueryString("expiringDate") || "1");
const currentDate = new Date().getTime();
let maxTime = 60;
export default function Register() {
  const [form] = Form.useForm();
  const history = useHistory();
  const [enterpriseName, setEnterpriseName] = useState("");
  const [userName, setUserName] = useState("");

  const [codeInfo, setCodeInfo] = useState<{
    btnDisabled: boolean;
    btnText: string;
    mobile: string;
  }>({
    btnDisabled: false,
    btnText: "发送",
    mobile: "",
  });

  useEffect(() => {
    instance
      .get(
        `/oa/staff/getStaffInfoAndCorpNameById?uuid=${userId}&corpId=${corpId}`
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          const data = resp.data.Data;
          setUserName(data.name);
          setEnterpriseName(data.enterpriseName);
        }
      });
  }, []);
  const onSubmit = async () => {
    const values = form.getFieldsValue();
    const resp = await instance.post("/oa/staff/saveStaffInfo", {
      mobile: values.mobile,
      name: values.name,
      password: values.password,
      repassword: values.repassword,
      corpId: corpId,
      code: values.code,
      inviter:userId,
    });
    if (resp.data.Status === "1") {
      history.push(`/success`);
    }
  };

  const sendCode = useCallback((mobile: string) => {
    const word = CryptoJs.MD5(`${mobile}tysoft`).toString();
    instance
      .post("/oa/registerDetail/newGetVerifyCode", {
        mobile: mobile,
        inCode: word,
      })
      .then((resp) => {
        if (resp.data.Status === "1") {
          Toast.show({
            content: "验证码发送成功",
          });
          const timer = setInterval(() => {
            if (maxTime > 0) {
              --maxTime;
              setCodeInfo((prevState) => ({
                ...prevState,
                btnText: `${maxTime}s`,
                btnDisabled: true,
                mobile: mobile,
              }));
            } else {
              clearInterval(timer);
              maxTime = 60;
              setCodeInfo((prevState) => ({
                ...prevState,
                btnText: "发送",
                btnDisabled: false,
                mobile: mobile,
              }));
            }
          }, 1000);
        } else {
          //
        }
      });
  }, []);

  const checkPhoneNumber = useCallback(async (mobile: string) => {
    return await instance.post("/oa/registerDetail/checkPhoneNumberByEnterprise", {
      num: mobile,
      corpId:corpId,
    });
  }, []);

  useEffect(() => {
    document.title = "邀请加入";
  }, []);

  return (
    <RegisterWrapper style={{ background: isMobile() ? "#f8f8f7" : "#fff" }}>
      {currentDate >= expiringDate ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            background: "#fff",
          }}>
          <Result status="info" title="链接已失效" description="" />
        </div>
      ) : (
        <>
          <main className="main">
            <Image className="logo" src={"/logo.png"} />
            <div className="user-box">
              <span className="user">「{userName}」 </span> 邀请您
            </div>
            <div className="company-box">加入「{enterpriseName}」团队</div>
            <Form
              layout="horizontal"
              onFinish={onSubmit}
              form={form}
              className={isMobile() ? "mobile-form" : "pc-form"}
              style={{ width: isMobile() ? "100%" : "400px", margin: "0 auto" }}
              footer={
                <Button block type="submit" color="primary" size="large">
                  加入团队
                </Button>
              }>
              <Form.Item
                name="name"
                label="用户名"
                rules={[{ required: true, message: "用户名不能为空" }]}>
                <Input placeholder="请输入" autoFocus className="fs14" />
              </Form.Item>
              <Form.Item
                name="mobile"
                label="手机号"
                rules={[
                  { required: true, message: "手机号不能为空" },
                  {
                    pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
                    message: "手机号格式错误！",
                  },
                ]}>
                <Input placeholder="请输入" className="fs14" />
              </Form.Item>
              <Form.Item
                label="验证码"
                name="code"
                rules={[{ required: true, message: "验证码不能为空" }]}
                extra={
                  codeInfo.btnDisabled ? (
                    <span>{codeInfo.btnText}</span>
                  ) : (
                    <a
                      onClick={async () => {
                        const mobile = form.getFieldValue("mobile");
                        const re = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                        if (!mobile) {
                          Toast.show({
                            content: "请输入手机号",
                          });
                          return;
                        }
                        if (!re.test(mobile)) {
                          return;
                        }
                        const resp = await checkPhoneNumber(
                          form.getFieldValue("mobile")
                        );
                        if (resp.data.Status === "0") {
                          Toast.show({
                            content: resp.data.Data,
                          });
                          return;
                        }
                        sendCode(form.getFieldValue("mobile"));
                      }}>
                      {codeInfo.btnText}
                    </a>
                  )
                }>
                <Input placeholder="请输入" />
              </Form.Item>
              <Form.Item
                name="password"
                label="密码"
                rules={[
                  { required: true, message: "密码不能为空" },
                  {
                    pattern: /^[A-Za-z0-9]{6,}$/,
                    message: "密码长度至少六位",
                  },
                ]}>
                <Input
                  // clearable
                  type="password"
                  placeholder="请输入"
                  className="fs14"
                />
              </Form.Item>
              <Form.Item
                name="repassword"
                label="再次输入"
                rules={[
                  { required: true, message: "密码不能为空" },
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject("两次输入的密码不匹配");
                    },
                  }),
                  {
                    pattern: /^[A-Za-z0-9]{6,}$/,
                    message: "密码长度至少六位",
                  },
                ]}>
                <Input
                  // clearable
                  type="password"
                  placeholder="请输入"
                  className="fs14"
                />
              </Form.Item>
            </Form>
          </main>
        </>
      )}
    </RegisterWrapper>
  );
}
